<template>
  <div class="administrators-list">
    <PageHeader
      title="Administrateurs"
      :has-search="true"
      :has-actions="true"
      v-model="query"
      :has-back="true"
      @back="goBack"
    >
      <md-button
        class="md-primary md-raised"
        @click="$router.push('/admin/administrators/create')"
      >
        Créer un administrateur
      </md-button>
    </PageHeader>

    <div class="administrators-list-content page-layout">
      <!-- La liste des entreprises -->
      <sortable-list
        link="/admin/administrators/view/"
        defaultSort="created_at"
        defaultSortType="asc"
        :items="filter"
        :parameters="listParameters"
        :hasPagination="true"
      >
      </sortable-list>
    </div>
  </div>
</template>

<script>
import usersModel from "../../../model/users";
import PageHeader from "@/components/PageHeader";

export default {
  components: { PageHeader },
  data() {
    return {
      isDebug: false,
      query: "",
      data: [],
      listParameters: [
        {
          name: "Prénom",
          key: "firstname",
        },
        {
          name: "Nom",
          key: "lastname",
        },
        {
          name: "Email",
          key: "email",
        },
        {
          name: "Cabinet",
          key: "organization_name",
        },
        {
          name: "Date de création",
          key: "created_at",
          format: this.$$filters.formatTimestamp,
        },
      ],
    };
  },
  methods: {
    goBack() {
      window.history.back();
    },
  },
  mounted() {
    usersModel.getAll().then(data => {
      this.data = data;
    });
  },
  computed: {
    filter() {
      if (this.query === "") {
        return this.data;
      } else {
        let q = this.query.toLowerCase();
        return this.data.filter(item => {
          return (
            item.firstname.toLowerCase().indexOf(q) > -1 ||
            item.lastname.toLowerCase().indexOf(q) > -1 ||
            item.email.toLowerCase().indexOf(q) > -1
          );
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.administrators-list {
  .debug-log {
    max-height: 200px;
    overflow-y: scroll;
  }
}
</style>
